import React from "react";
import { Link } from "react-router-dom";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import SEO, { BreadcrumbSchema } from "../components/SEO";
import { ArrowUpRight } from "lucide-react";

const CARDS = [
  { to: "/disaster-recovery", title: "Disaster Recovery & FEMA PA", desc: "FEMA Public Assistance, cost estimating, procurement compliance and hazard mitigation. 150+ grants managed.", img: null },
  { to: "/federal", title: "Federal Construction & Teaming", desc: "Past construction for the U.S. Army Corps of Engineers and the Department of Veterans Affairs. Available for teaming and subcontract work.", img: "https://customer-assets-gfyr7b9c.emergentagent.net/job_company-site-new/artifacts/3bd2d6151a2fed5d_bcpeabody-kissimmee-river-restoration-reach-3-backfill-aerial-01.jpg" },
];

const stats = [
  { n: "150+", t: "FEMA Public Assistance grants managed" },
  { n: "$300M+", t: "Estimated value of grants managed" },
  { n: "60+", t: "Private nonprofit organizations served" },
  { n: "2006", t: "Founded in Tampa" },
];

export default function FederalServices() {
  return (
    <>
      <SEO title="Disaster Recovery & FEMA Public Assistance | BCPeabody" description="FEMA Public Assistance and disaster recovery support for public agencies, nonprofits and the firms that support them, from a Service-Disabled Veteran-Owned contractor that builds." path="/federal-services" />
      <BreadcrumbSchema items={[{ name: "Home", url: "https://bcpeabody.com/" }, { name: "Disaster Recovery", url: "https://bcpeabody.com/federal-services" }]} />
      <Nav transparentOnTop />

      <section className="relative min-h-[55vh] flex items-end overflow-hidden bg-ink text-cream-light">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-copper/10 blur-[160px]" />
        </div>
        <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 w-full pb-14 pt-32">
          <div className="text-[11px] tracking-[0.18em] uppercase text-copper-light mb-5">Disaster Recovery</div>
          <h1 className="font-serif font-medium tracking-tight mb-5 leading-[1.05]" style={{ fontSize: "clamp(32px, 5vw, 60px)" }}>Disaster Recovery & FEMA Public Assistance</h1>
          <p className="text-cream-light/80 max-w-3xl" style={{ fontSize: 18 }}>Recovery support for public agencies, nonprofits and the firms that support them, from a Service-Disabled Veteran-Owned contractor that builds.</p>
        </div>
      </section>

      <section className="bg-cream-light py-16 md:py-20">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {CARDS.map((c) => (
            <Link key={c.to} to={c.to} data-testid={`overview-card-${c.to.slice(1)}`} className="group block">
              <div className="relative h-[320px] overflow-hidden bg-ink mb-4">
                {c.img ? (
                  <img src={c.img} alt={c.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-[1200ms]" />
                ) : (
                  <div className="absolute -bottom-24 -left-24 w-[360px] h-[360px] rounded-full bg-copper/15 blur-[120px]" />
                )}
              </div>
              <h3 className="font-serif text-2xl text-ink tracking-tight mb-1">{c.title}</h3>
              <p className="text-sm text-ink/70">{c.desc}</p>
              <span className="inline-flex items-center gap-1 text-[11px] tracking-[0.14em] uppercase text-copper mt-3">Learn more <ArrowUpRight size={12} /></span>
            </Link>
          ))}
        </div>
      </section>

      <section className="bg-cream py-14" data-testid="overview-stats">
        <div className="max-w-[1200px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.n} className="border-l-2 border-copper pl-4">
              <div className="font-serif text-4xl md:text-5xl text-ink leading-none mb-2">{s.n}</div>
              <div className="text-xs text-ink/70 leading-snug">{s.t}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-ink text-cream-light py-20 text-center">
        <div className="max-w-[800px] mx-auto px-6">
          <h2 className="font-serif font-medium mb-8 tracking-tight" style={{ fontSize: "clamp(26px, 3.2vw, 36px)" }}>Talk with us about your program.</h2>
          <Link to="/contact?type=disaster-recovery" data-testid="overview-cta" className="btn-copper">Start a Project →</Link>
        </div>
      </section>

      <Footer />
    </>
  );
}
